<template>
  <div class="column_center_start body">
  </div>
</template>

<script>
import auth from "@/utils/auth.utils"
export default {
  computed: {
    isLogin() {
      return this.$store.getters["userData/isLogin"];
    },
  },
  data() {
    return {};
  },
  beforeMount() {
    this.redirect();
  },
  methods: {
    async redirect() {
      try {
        // 檢查是否有 line 登入資料
        const lineLoginData = this.$store.state.line.lineLoginData
        const accessToken = this.$store.getters['line/accessToken']
        if (
          !lineLoginData ||
          !accessToken
        ) {
          console.log("no access token, stay at home page");
          return;
        } else {
          // 取的傳送出去的 json data
          const queryData = this.$route.query;
          console.log("query data", queryData);
          if (!queryData || Object.keys(queryData).length === 0) {
            console.log("no query data, stay at home page");
            return;
          }
          let stateData = {}
          if (queryData.state) {
            stateData = {...JSON.parse(queryData.state)};
            console.log("queryData contains stateData", stateData);
          }
          if (stateData.data) {
            const data = stateData.data;
            const dataKeys = Object.keys(data);
            let path = `/${stateData.store}`;
            dataKeys.forEach((key) => {
              path += `/${data[key]}`;
            });
            console.log("contain callback data", path);
            this.$router.push({
              path: path,
            });
          } else {
            this.$router.push({
              path: `/${stateData.store}`,
            });
          }
        }
      } catch (error) {
        //顯示彈窗
        auth.logout();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.body {
  background-color: #eeeeee;
  height: 100vh;
  width: 100vw;

  button {
    margin-top: 10px;
  }
}
</style>
